import { type IAgentBillingQuery } from 'application/querySchemas/IAgentBillingQuery';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentBillingListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAgentBillingListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentBillingQuery implements IAgentBillingQuery {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentBillingListClient')
        public readonly agentBillingListClient: IAgentBillingListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentBillingListClient.get({
            token: this.agentUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
